import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { State } from '@/store/modules/useChapterState';
import Viewport from '@/store/modules/Viewport';

gsap.registerPlugin(ScrollTrigger);


export default class HeroScrollTrigger {

  private timelines: gsap.core.Timeline[] = [];

  root: HTMLElement; 
  btnLeft: HTMLElement;
  btnRight: HTMLElement; 
  scrollIndicator: HTMLElement; 
  state: State;

  constructor(root: HTMLElement, btnLeft: HTMLElement, btnRight: HTMLElement, scrollIndicator: HTMLElement, state: State) {
    this.root = root;
    this.btnLeft = btnLeft;
    this.btnRight = btnRight;
    this.state = state;
    this.scrollIndicator = scrollIndicator;

    this.create()
  }

  create() {
    const { root, btnLeft, btnRight, scrollIndicator, state } = this;

    this.destroy();
    // console.log('[HeroScrollTrigger] create')
    this.timelines.push(gsap.timeline({
        scrollTrigger: {
          trigger: root,
          start: 'top top',
          end: 'bottom top',
          scrub: true,
          // markers: true
        },
        defaults: { ease: "none", duration: 1 }
      })
      .fromTo(
        state, 
        { scrollProgress: 0 },
        { scrollProgress: 1 },
        0
      )
    );

    this.timelines.push(gsap.timeline({
      scrollTrigger: {
        trigger: root,
        start: 'top+=10% top',
        end: 'bottom-=10% top',
        scrub: false,
        // markers: true,
        toggleActions: 'play none reverse reverse',
      },
      defaults: { ease: "none", duration: 1 }
    })
      .fromTo(
        btnLeft,
        {
          xPercent: 0,
        },
        {
          xPercent: -100,
          ease: 'quart.out'
        },
        0
      )
      .fromTo(
        btnRight,
        {
          xPercent: 0,
        },
        {
          xPercent: 100,
          ease: 'quart.out'
        },
        0
      )
      .fromTo(
        scrollIndicator,
        {
          opacity: 1,
        },
        {
          opacity: 0,
          ease: 'quart.out',
          duration: 1
        },
        0
      )
    );
  }

  refresh() {
    this.timelines.forEach(timeline => {
      if (timeline.scrollTrigger) {
        timeline.scrollTrigger.refresh();
      }
    })
  }

  destroy() {
    this.timelines.forEach(timeline => {
      if (timeline.scrollTrigger) {
        timeline.scrollTrigger.kill();
      }
      timeline.kill();
    });
    this.timelines = [];
  }
}